import {Injectable} from '@angular/core';
import {Subject} from "rxjs";

@Injectable()
export class NavDataService {
  private refreshChange = new Subject<any>();
  private refreshChildChange = new Subject<any>();
  refreshDataEmitted = this.refreshChange.asObservable();
  refreshChildDataEmitted = this.refreshChildChange.asObservable();

  constructor() { }

  emitRefreshChange(change: any) {
    this.refreshChange.next(change);
  }

  emitRefreshChildChange(change: any) {
    this.refreshChildChange.next(change);
  }
}
